import { useEffect, useState } from "react";
import { api } from "../../lib/api";

const TYPE_LABELS = { press: "Press", art_sales: "Art Sales", partnerships: "Partnerships", other: "Other" };

export default function EnquiriesPage() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/admin/enquiries").then((res) => setItems(res.data || [])).catch(() => {});
  }, []);

  const downloadCsv = async () => {
    const res = await api.get("/admin/enquiries.csv", { responseType: "blob" });
    const blobUrl = URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = blobUrl;
    a.download = "enquiries.csv";
    a.click();
    URL.revokeObjectURL(blobUrl);
  };

  return (
    <div data-testid="admin-enquiries">
      <div className="flex items-center justify-between">
        <h1 className="h-condensed text-4xl">Enquiries</h1>
        <button type="button" onClick={downloadCsv} className="link-arrow text-xs" data-testid="enquiries-export-csv">
          Export CSV
        </button>
      </div>
      <div className="mt-8 overflow-x-auto border-t border-charcoal">
        <table className="w-full text-left text-sm font-light">
          <thead>
            <tr className="border-b border-charcoal">
              <th className="eyebrow py-3 pr-6 text-[0.6rem]">Date</th>
              <th className="eyebrow py-3 pr-6 text-[0.6rem]">Name</th>
              <th className="eyebrow py-3 pr-6 text-[0.6rem]">Email</th>
              <th className="eyebrow py-3 pr-6 text-[0.6rem]">Type</th>
              <th className="eyebrow py-3 text-[0.6rem]">Message</th>
            </tr>
          </thead>
          <tbody>
            {items.map((e) => (
              <tr key={e.id} className="border-b border-stone align-top" data-testid={`enquiry-row-${e.id}`}>
                <td className="whitespace-nowrap py-3 pr-6">{e.created_at ? new Date(e.created_at).toLocaleDateString("en-GB", { dateStyle: "medium" }) : ""}</td>
                <td className="py-3 pr-6">{e.name}</td>
                <td className="py-3 pr-6"><a className="underline underline-offset-2" href={`mailto:${e.email}`}>{e.email}</a></td>
                <td className="py-3 pr-6">{TYPE_LABELS[e.type] || e.type}</td>
                <td className="max-w-md py-3">{e.message}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {items.length === 0 && <p className="py-8 text-sm font-light opacity-60">No enquiries yet.</p>}
      </div>
    </div>
  );
}
